import { render, staticRenderFns } from "./TeacherCardOneWordLabel.vue?vue&type=template&id=292ef940&scoped=true&"
import script from "./TeacherCardOneWordLabel.vue?vue&type=script&lang=js&"
export * from "./TeacherCardOneWordLabel.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardOneWordLabel.vue?vue&type=style&index=0&id=292ef940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ef940",
  null
  
)

export default component.exports